<template>
  <BaseModal class="product-modal" v-model="isOpenModal">
    <template v-slot:header>
      {{ header }}
    </template>
    <BaseOrderModal
      @closeOrder="openedOrder = ''"
      :orderUUID="openedOrder"
      v-model="showOrderModal"
      @orderUpdated="reloadQuotes"
      @quoteConverted="openOrderFromCustomer"
    />
    <div class="product-view">
      <!--  Navigation  -->
      <div class="navigation">
        <div class="bar">
          <button
            @click="selectedSection = 'infoauto-data'"
            class="tablinks"
            :class="{ active: selectedSection == 'infoauto-data' }"
          >
            General data
          </button>
          <button
            @click="selectedSection = 'infoauto-documents'"
            class="tablinks"
            :class="{ active: selectedSection == 'infoauto-documents' }"
          >
            Infoauto documents
          </button>
          <button
            @click="selectedSection = 'addresses-phones'"
            class="tablinks"
            :class="{ active: selectedSection == 'addresses-phones' }"
          >
            Addresses & Phones
          </button>
          <button
            @click="selectedSection = 'quotes'"
            class="tablinks"
            :class="{ active: selectedSection == 'quotes' }"
          >
            Quotes
          </button>
          <button
            v-if="canViewCustomerHistory"
            @click="selectedSection = 'orders'"
            class="tablinks"
            :class="{ active: selectedSection == 'orders' }"
          >
            Orders
          </button>
        </div>
      </div>
      <div class="content" v-if="customerId">
        <template v-if="selectedSection == 'infoauto-data'">
          <div class="top-row">
            <InfoautoCustomerData :customerId="customerId" />
            <InfoautoLinkedCustomers
              :customerId="customerId"
              :customerName="
                customerFull
                  ? `${customerFull.generalInfo.name} ${customerFull.generalInfo.surname}`
                  : null
              "
              class="linked-panel"
              @editCustomer="
                (id, customer) => $emit('editWebCustomer', id, customer)
              "
            />
          </div>
          <InfoautoCustomerStats
            v-if="canViewCustomerHistory"
            :customerId="customerId"
            class="stats-full"
          />
        </template>
        <template v-if="selectedSection == 'infoauto-documents'">
          <InfoautoCustomerDocuments
            :customerId="customerId"
          ></InfoautoCustomerDocuments>
        </template>
        <template v-if="selectedSection == 'addresses-phones'">
          <InfoautoCustomerAddressesPhones
            :customerId="customerId"
          ></InfoautoCustomerAddressesPhones>
        </template>
        <template v-if="selectedSection == 'quotes'">
          <QuotesList
            ref="quotesList"
            :customerInfoautoId="customerId"
            class="quotes-full"
            @openQuote="openOrderFromCustomer"
          />
        </template>
        <template v-if="selectedSection == 'orders' && canViewCustomerHistory">
          <InfoautoCustomerOrders
            :customerId="customerId"
            class="orders-full"
            @openOrder="openOrderFromCustomer"
          />
        </template>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import InfoautoCustomerData from "../customer/InfoautoCustomerData.vue";
import InfoautoCustomerDocuments from "../customer/InfoautoCustomerDocuments.vue";
import InfoautoCustomerAddressesPhones from "../customer/InfoautoCustomerAddressesPhones.vue";
import InfoautoLinkedCustomers from "../customer/InfoautoLinkedCustomers.vue";
import InfoautoCustomerStats from "../customer/InfoautoCustomerStats.vue";
import QuotesList from "../quotes/QuotesList.vue";
import InfoautoCustomerOrders from "../customer/InfoautoCustomerOrders.vue";
import { infoautoGetSingleCustomer } from "@/api/store/Infoauto.js";
export default {
  components: {
    InfoautoCustomerData,
    InfoautoCustomerDocuments,
    InfoautoCustomerAddressesPhones,
    InfoautoLinkedCustomers,
    InfoautoCustomerStats,
    QuotesList,
    InfoautoCustomerOrders
  },
  props: {
    customerId: {
      type: String,
      required: true
    },
    initialSection: {
      type: String,
      default: "infoauto-data"
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showEditCustomerForm: false,
      showInfoautoCustomerFinder: false,
      customerFull: null,
      processing: false,
      isOpenModal: this.value,
      editCustomer: false,
      customerMainInfoOriginal: null,
      selectedSection: this.initialSection || "infoauto-data",
      loading: false,
      showOrderModal: false,
      openedOrder: "",
      openedProduct: "",
      priceLevelOptions: []
    };
  },
  computed: {
    sellers() {
      return this.$store.getters["general/getSellers"];
    },
    currentUser() {
      return this.$store.getters["auth/currentUser"];
    },
    canViewCustomerHistory() {
      return this.$store.getters["auth/userHasPermission"](
        "can_view_customer_history"
      );
    },
    header() {
      if (!this.customerFull) return "";
      return `Customer - ${this.customerFull.generalInfo.name} ${this.customerFull.generalInfo.surname}`;
    },
    isOpen() {
      return this.value;
    },
    customerUpdated() {
      if (!this.customerMainInfoOriginal) {
        return false;
      }
      return (
        this.customerMainInfoOriginal !=
        JSON.stringify(this.customerFull.generalInfo)
      );
    }
  },
  watch: {
    isOpenModal(val) {
      this.$emit("input", val);
      if (!val) {
        this.$emit("closedCustomer");
      }
    },
    value(val) {
      this.isOpenModal = val;
    },
    initialSection(val) {
      if (val) {
        this.selectedSection = val;
      }
    },
    customerId: {
      immediate: true,
      handler(val) {
        if (val != "") {
          this.selectedSection = this.initialSection || "infoauto-data";
          this.customerFull = null;
          this.loadCustomerFull();
        }
      }
    }
  },
  methods: {
    async loadCustomerFull() {
      try {
        this.customerFull = await infoautoGetSingleCustomer(this.customerId);
      } catch (error) {
        this.customerFull = null;
      }
    },
    openOrderFromCustomer(orderNumber) {
      this.openedOrder = orderNumber;
      this.showOrderModal = true;
    },
    reloadQuotes() {
      if (this.$refs.quotesList) this.$refs.quotesList.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";
.top-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  width: 100%;
  align-items: start;
  @media screen and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}
.stats-full {
  width: 100%;
}
.quotes-full {
  width: 100%;
  height: 100%;
}
.orders-full {
  width: 100%;
  height: 100%;
}
.loading-full {
  height: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-modal {
  &:focus {
    outline: none;
  }
  // El header del slot puede quedar bajo si el nombre tarda en cargar;
  // garantizamos que el botón de cerrar sea visible y con buen contraste
  ::v-deep .modal-content > .header .close {
    color: #374151;
    font-size: 32px;
    line-height: 1;
    z-index: 70;
    &:hover {
      color: #000;
    }
  }
  &.modal {
    padding-top: 20px;
    ::v-deep > .modal-content {
      height: calc(100% - 20px);
      width: 98%;
      padding: 0px;
      overflow-y: hidden;
    }
    ::v-deep > .modal-bg {
      height: 100%;
    }
  }
}
.product-view {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .content {
    padding: 10px 10px;
    width: 100%;
    flex: 1 1 0;
    min-height: 0;
    flex-direction: row;
    overflow-y: auto;
    position: relative;
    align-content: flex-start;
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .box {
      width: 33%;
      border: 1px solid grey;
      border-radius: 5px;
      margin-bottom: 5px;
      &.full {
        width: 100%;
      }
      .box-header {
        width: 100%;
        padding: 5px 10px;
        background-color: grey;
        color: white;
      }
      table {
        width: 100%;
      }
      .box-content-block {
        .grid-info {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-column-gap: 30px;
          // .grid-info-item {
          // }
        }
        width: 100%;
        padding: 5px 10px;
        .input-item {
          margin: 5px 0px;
          display: flex;
          flex-direction: column;
          .badge-list {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin: 10px 0px;
          }
        }
      }
    }
  }
}
</style>
